// extracted by mini-css-extract-plugin
module.exports = {"kit-price":"KitPrice_kit-price__S4_x4","kit-price__discount":"KitPrice_kit-price__discount__T7PPH"};